import { Row } from 'common/types/scalarSpreadsheet';

const getClassName = (needs_actualization: boolean, row: Row): string | null | undefined => {
  if (needs_actualization && row.className) return `${row.className} warning`;
  if (needs_actualization) return 'warning';
  return row.className;
};
export default getClassName;
